import { ClientHelper } from '../client/CreateNswagClient';
import { AssistantDefinition } from '../client/SmartAssistantBackendClient';

export class AssistantService {
  private static normalizeText(value?: string | null): string {
    return (value ?? '').trim();
  }

  static buildPayload(assistant: AssistantDefinition): AssistantDefinition {
    const normalizeText = AssistantService.normalizeText;
    return new AssistantDefinition({
      name: normalizeText(assistant.name) || undefined,
      internalName: normalizeText(assistant.internalName) || undefined,
      topics: normalizeText(assistant.topics) || undefined,
      vectorStoreId: normalizeText(assistant.vectorStoreId) || undefined,
      isDefault: assistant.isDefault ?? false,
      assistentPrompt: normalizeText(assistant.assistentPrompt) || undefined,
      assistentLlmModel: normalizeText(assistant.assistentLlmModel) || undefined,
      promptDefinitions: assistant.promptDefinitions ?? undefined,
    });
  }

  static async saveAssistant(token: string, assistant: AssistantDefinition): Promise<void> {
    const configClient = ClientHelper.createConfigClient(token);
    const payload = AssistantService.buildPayload(assistant);
    if (assistant.id) {
      await configClient.updateAssistant(assistant.id, payload);
      return;
    }
    await configClient.createAssistant(payload);
  }

  static async deleteAssistant(token: string, assistant: AssistantDefinition): Promise<void> {
    if (!assistant.internalName) return;
    const configClient = ClientHelper.createConfigClient(token);
    await configClient.deleteAssistant(assistant.internalName);
  }

  static async listAssistants(token: string) {
    const configClient = ClientHelper.createConfigClient(token);
    return configClient.listAssistants();
  }

  static async listAssistantPrompts(token: string, assistantInternalName: string) {
    const configClient = ClientHelper.createConfigClient(token);
    return configClient.listAssistantPrompts(assistantInternalName);
  }
}
